<template>
  <div class="list-page oversea-service">
    <div class="detail-banner">
      <div class="container">
        <h1>出海服务</h1>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div v-if="loading" class="empty-block">加载中…</div>

        <div v-else class="os-cat-grid">
          <div
            v-for="(cat, idx) in categories"
            :key="idx"
            class="os-cat-card"
            @click="openCat(cat, idx)"
          >
            <img v-if="cat.image" :src="cat.image" class="os-cat-icon" @error="onImgError" />
            <span v-else class="os-cat-ph">{{ cat.title.slice(0, 1) }}</span>
            <div class="os-cat-text">
              <div class="os-cat-title">{{ cat.title }}</div>
              <div class="os-cat-sub">{{ cat.subtitle }}</div>
            </div>
            <span class="os-cat-arrow"></span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchOverseaService } from '../api/home'

export default {
  name: 'OverseaService',
  data () {
    return {
      categories: [],
      loading: true
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        this.categories = await fetchOverseaService()
      } catch (e) {
        this.categories = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    openCat (cat, idx) {
      // 升级中模块提示
      if (cat.isUpdate) {
        this.$toast.show({ message: cat.tips || '该功能模块升级中，敬请期待！', type: 'info' })
        return
      }
      const page = cat.page || ''
      if (page.indexOf('oversea_report_list') > -1) {
        this.$router.push('/oversea-report')
      } else if (page.indexOf('oversea_service_list') > -1) {
        this.$router.push('/oversea-service-list/' + idx)
      } else if (page.indexOf('expert_list') > -1) {
        this.$router.push('/experts')
      } else {
        this.$toast.show({ message: '该服务内容整理中，敬请期待', type: 'info' })
      }
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.os-cat-grid {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}
.os-cat-card {
  display: flex;
  align-items: center;
  gap: 18px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 22px 24px;
  cursor: pointer;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.os-cat-card:hover {
  box-shadow: var(--shadow-hover);
  transform: translateY(-2px);
}
.os-cat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  object-fit: contain;
  background: var(--blue-soft);
  flex-shrink: 0;
}
.os-cat-ph {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: var(--primary);
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.os-cat-text {
  flex: 1;
  min-width: 0;
}
.os-cat-title {
  font-size: 19px;
  font-weight: 800;
  color: var(--text-main);
}
.os-cat-sub {
  font-size: 13.5px;
  color: var(--text-sub);
  margin-top: 6px;
}
.os-cat-arrow {
  width: 12px;
  height: 12px;
  border-top: 3px solid var(--primary);
  border-right: 3px solid var(--primary);
  transform: rotate(45deg);
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .os-cat-grid {
    grid-template-columns: 1fr;
  }
}
</style>
